






































import { Component, Prop, Vue } from "vue-property-decorator";
import { COLOR } from "@/consts/consts";

@Component
export default class TwoPlayer extends Vue {
  @Prop() private cards!: Array<any>;
  selected = "";
  COLOR = COLOR;

  get cardsList() {
    return [
      {
        key: "プレーヤー１",
        cards: this.cards.slice(0, 5).sort((a, b) => a.index - b.index)
      },
      {
        key: "プレーヤー２",
        cards: this.cards.slice(5, 10).sort((a, b) => a.index - b.index)
      }
    ];
  }
}
